import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCancer = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 36,
	height: 36,
	viewBox: "0 0 36 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M25.3379 8.49505C19.6346 5.47332 12.2135 6.19722 7.33333 10.6667M28.6667 25.3334C23.7897 29.7487 16.404 30.5087 10.6634 27.6134M15.3333 14.0001C15.3333 16.5774 13.244 18.6667 10.6667 18.6667C8.08934 18.6667 6 16.5774 6 14.0001C6 11.4228 8.08934 9.33341 10.6667 9.33341C13.244 9.33341 15.3333 11.4228 15.3333 14.0001ZM20.6667 22.0001C20.6667 19.4228 22.756 17.3334 25.3333 17.3334C27.9107 17.3334 30 19.4228 30 22.0001C30 24.5774 27.9107 26.6667 25.3333 26.6667C22.756 26.6667 20.6667 24.5774 20.6667 22.0001Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgCancer;
